import React from "react";
import { useTranslation } from "react-i18next";

import StepButtons from "./stepButtons";
import { getSteps } from "./util";

const Review = ({ initialState, previousStep, country, nextStep }) => {
  const { t } = useTranslation();
  const steps = getSteps(country);

  return (
    <>
      <div className="register-provider-review w-100">
        <h4 className="title">{t(`${baseName}title`)}</h4>
        {steps.flatMap(({ name, Component }) => {
          return name ? (
            <Component
              key={name}
              initialState={initialState[name]}
              reviewMode
            />
          ) : (
            []
          );
        })}
        <div className="d-flex align-items-end">
          <StepButtons previousStep={previousStep} nextStep={nextStep} />
        </div>
      </div>
    </>
  );
};

export default Review;

const baseName = "registerProvider.forms.review.";
